
/**
 * Regular expression pattern for validating SSN strings.
 */
export const SSN_REGEXP = /^\d{6}-?\d{2}-?\d{2}$/;

/**
 * Regular expression pattern for validating email addresses.
 */
// tslint:disable-next-line:max-line-length
export const EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;

/**
 * Regular expression pattern for validating urls.
 */
// eslint-disable-next-line no-useless-escape
export const URL_REGEXP = /^https?:\/\/(?:(?:(?:[\w\.\-\+!$&'\(\)*\+,;=]|%[0-9a-fA-F]{2})+:)*(?:[\w\.\-\+%!$&'\(\)*\+,;=]|%[0-9a-fA-F]{2})+@)?(?:(?:[a-zA-Z0-9\-\.]|%[0-9a-fA-F]{2})+|(?:\[(?:[0-9a-fA-F]{0,4}:)*(?:[0-9a-fA-F]{0,4})\]))(?::[0-9]+)?(?:[\/|\?](?:[\w#!:\.\?\+=&@$'~*,;\/\(\)\[\]\-]|%[0-9a-fA-F]{2})*)?$/;

/**
 * Regular expression pattern for validating RFC4122 UUID strings.
 *
 * @see https://tools.ietf.org/html/rfc4122
 */
export const UUID_REGEXP = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
